import proxy from "../proxy";
const userFactor = {
  list:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("userFactor/myList", data, { dispatch }),
  info:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("userFactor/info", data, { dispatch }),
  update:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.put("userFactor/update", data, { dispatch });
      await proxy.get("userFactor/info", data2, { dispatch });
    },
  payment:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.post("userFactor/payment", data, { dispatch });
    },
  verify:
    (data = {}) =>
    async (dispatch) => {
      await proxy.post("userFactor/verify", data, { dispatch });
    },
  add:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.post("userFactor/add", data, { dispatch });
      await proxy.get("userFactor/list", data2, { dispatch });
    },
  deleteUserOffCode:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.delete("userFactor/deleteUserOffCode", data, { dispatch });
      await proxy.get("userFactor/info", data2, { dispatch });
    },
};

export default userFactor;
